import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

export const HotelLocation = ({ geoCodes, locationRef }) => {

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY
    })

    if(!geoCodes) return null;

    return (
        <div className='mb-5'>
            <h3 ref={locationRef} className='mb-3'>Location</h3>
            <div
                style={{
                    borderRadius: '10px',
                    overflow: 'hidden'
                }}
            >
                {
                    isLoaded ?
                        <GoogleMap
                            mapContainerStyle={{
                                minHeight: "500px",
                                minWidth: "250px",
                                width: '100%'
                            }}
                            zoom={18}
                            center={{
                                lat: geoCodes.latitude,
                                lng: geoCodes.longitude
                            }}
                        >
                            <Marker
                                position={{
                                    lat: geoCodes.latitude,
                                    lng: geoCodes.longitude
                                }}
                            />
                        </GoogleMap> : null
                }
            </div>
        </div>
    )
}
